export default {
    methods: {
        showWebWidget: function () {
            window.zE('webWidget', 'show')
            window.zE('webWidget', 'open')
        },
    },
}
